import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export const Tooltip = (props) => {
    if (!props.open) {
        return null;
    }
    return _jsx(_Fragment, { children: _jsx("div", { ref: props.tooltipRef, role: "tooltip", className: "position-absolute p-2 rounded bg-light text-start", style: { 'zIndex': 1000, 'width': '250px', 'left': '50%', 'transform': 'translateX(-50%)' }, children: props.children }) });
};
export const useTooltip = (content) => {
    const refTrigger = React.useRef(null);
    const refTooltip = React.useRef(null);
    const [stateOpen, setOpen] = React.useState(false);
    const isEventInside = React.useCallback((target) => {
        if (!(target instanceof Node)) {
            return false;
        }
        return (refTrigger.current?.contains(target) || refTooltip.current?.contains(target));
    }, []);
    React.useEffect(() => {
        const onPointerDown = (e) => {
            if (!isEventInside(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('pointerdown', onPointerDown);
        return () => document.removeEventListener('pointerdown', onPointerDown);
    }, [isEventInside]);
    return {
        'Tooltip': () => Tooltip({
            'tooltipRef': refTooltip,
            'open': stateOpen,
            'children': content,
        }),
        refTrigger,
        'triggerProps': {
            onMouseEnter: () => setOpen(true),
            onMouseLeave: () => setOpen(false),
            onFocus: () => setOpen(true),
            onBlur: () => setOpen(false),
            'aria-describedby': stateOpen ? 'tooltip' : undefined,
        },
    };
};
